import type {ListProps} from '@refinedev/mui';
import {List as ListMui} from '@refinedev/mui';
import {FC, ReactNode} from 'react';

import {CustomList} from '@components/crud/_partial/custom-list';

type CustomListProps = {
  auto?: boolean;
  title?: string | ReactNode;
  hideBreadcrumbs?: boolean;
} & Omit<ListProps, 'title'>;

export const List: FC<CustomListProps> = ({auto = false, ...props}) => {
  return auto ? <ListMui {...props} /> : <CustomList {...props} />;
};
